import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const landerImageComponent = {
  image: 'lander-image.image',
  root: 'lander-image.root',
  skeleton: 'lander-image.skeleton',
} as const satisfies ComponentLocatorMap;
